module.exports = __webpack_public_path__ + "static/media/matching-score-rank-4.7f9726da.png";